import { render, staticRenderFns } from "./VideoAnswerRecordsDialog.vue?vue&type=template&id=341feb34&scoped=true"
import script from "./VideoAnswerRecordsDialog.vue?vue&type=script&lang=js"
export * from "./VideoAnswerRecordsDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoAnswerRecordsDialog.vue?vue&type=style&index=0&id=341feb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341feb34",
  null
  
)

export default component.exports